import ShoppingCartOutlinedIcon from "@redotech/redo-icons/shopping-cart-01.svg";
import { ContentType } from "@redotech/redo-model/conversation";
import { ConversationMessage } from "@redotech/redo-model/conversation/conversation-message-db-parser";
import { memo, useMemo } from "react";
import { Flex } from "../flex";
import { Text } from "../text";
import * as toolResponseContentCss from "./tool-response-content.module.css";

//TODO: I think we can remove this when we purge old concierge code
interface ToolResponseContentProps {
  message: ConversationMessage;
  findActionableMessage: (
    toolCallId?: string | null,
  ) => ConversationMessage | undefined;
}

export const ToolResponseContent = memo(function ToolResponseContent({
  message,
  findActionableMessage,
}: ToolResponseContentProps) {
  const actionableMessage = useMemo(() => {
    return findActionableMessage(message.toolCallId);
  }, [message, findActionableMessage]);

  return actionableMessage?.contentType === ContentType.CART_ITEMS ? (
    <Flex
      align="center"
      dir="row"
      gap="md"
      maxW="full"
      overflow="hidden"
      shrink={0}
    >
      <Flex
        align="center"
        bgColor="tertiary"
        className={toolResponseContentCss.cartIconContainer}
        justify="center"
      >
        <ShoppingCartOutlinedIcon className={toolResponseContentCss.cartIcon} />
      </Flex>
      <Flex dir="column" flex={1} gap="xxs" overflow="hidden">
        <Text
          className={toolResponseContentCss.productTitle}
          fontSize="sm"
          fontWeight="semibold"
          maxW="full"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {actionableMessage.structuredContent?.productTitle || "Product Added"}
        </Text>
        <Text fontSize="xxs" textColor="tertiary">
          Added to cart
        </Text>
      </Flex>
    </Flex>
  ) : null;
});
